import React from 'react'

import styled from 'styled-components'

import { ICONS_NAME, IconV2 } from '../../'

import { Color, Transition } from '@/utils'

const IconElement = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 28px;
  width: 28px;
  border-radius: 4px;
  user-select: none;
  cursor: pointer;

  &,
  svg * {
    transition:
      fill ${Transition.fast},
      color ${Transition.fast};
  }

  :hover,
  :focus,
  :active {
    background: ${Color.white};
    box-shadow: 0px 4px 7px rgba(157, 173, 184, 0.2);
  }

  :hover,
  :focus {
    svg * {
      fill: ${Color.primary};
    }
  }

  :active svg * {
    fill: ${Color.textMain};
  }
`

export const HeaderIcon = ({ icon, onClick }) => (
    <IconElement onClick={onClick}>
        <IconV2 name={icon} color={Color.textSecondary} />
    </IconElement>
)
